import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Observable} from 'rxjs';
import {Config} from '../../../config/config';
import {TransferStateService} from './transfer-state.service';

@Injectable({
  providedIn: 'root'
})
export class NumbersService {

  constructor(private apiService: ApiService, private transferState: TransferStateService) {
  }

  getNumbers(): Observable<any> {
    return this.transferState.runApi(
      'numbers-numbers',
      this.apiService.translateApi((locale => this.apiService.get(Config.ENDPOINTS.numbers.numbers(), undefined, undefined, locale)))
    );
  }
}
